/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactDetailType } from './ContactDetailType';
import {
    ContactDetailTypeFromJSON,
    ContactDetailTypeFromJSONTyped,
    ContactDetailTypeToJSON,
    ContactDetailTypeToJSONTyped,
} from './ContactDetailType';

/**
 * 
 * @export
 * @interface ContactDetailRequest
 */
export interface ContactDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactDetailRequest
     */
    id: string | null;
    /**
     * 
     * @type {ContactDetailType}
     * @memberof ContactDetailRequest
     */
    type: ContactDetailType;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailRequest
     */
    comment: string | null;
}



/**
 * Check if a given object implements the ContactDetailRequest interface.
 */
export function instanceOfContactDetailRequest(value: object): value is ContactDetailRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function ContactDetailRequestFromJSON(json: any): ContactDetailRequest {
    return ContactDetailRequestFromJSONTyped(json, false);
}

export function ContactDetailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDetailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ContactDetailTypeFromJSON(json['type']),
        'value': json['value'],
        'comment': json['comment'],
    };
}

export function ContactDetailRequestToJSON(json: any): ContactDetailRequest {
    return ContactDetailRequestToJSONTyped(json, false);
}

export function ContactDetailRequestToJSONTyped(value?: ContactDetailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ContactDetailTypeToJSON(value['type']),
        'value': value['value'],
        'comment': value['comment'],
    };
}

